import React from 'react';
type Testimonial = {
  name: string;
  role: string;
  initials: string;
  color: string;
  quote: string;
};
const testimonials: Testimonial[] = [{
  name: 'Marek B.',
  role: 'Trener U16',
  initials: 'MB',
  color: 'from-blue-500/30 to-blue-700/10',
  quote: 'Kupiłem zestaw w niedzielę. W poniedziałek wszedłem na halę z gotowym planem. Moi zawodnicy od razu zauważyli różnicę w jakości ćwiczeń.'
}, {
  name: 'Katarzyna R.',
  role: 'Trenerka młodzieży',
  initials: 'KR',
  color: 'from-amber-500/30 to-amber-700/10',
  quote: 'Najlepsza inwestycja roku. Arkusze oceny i gotowe konspekty dały mi spokój, którego potrzebowałem po pracy.'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-20 px-4" data-id="element-213">
      <div className="max-w-6xl mx-auto" data-id="element-214">
        <div className="text-center mb-10 sm:mb-14" data-id="element-215">
          <span className="inline-block bg-secondary/10 border border-secondary/20 text-secondary font-bold text-xs px-3 py-1.5 rounded-full mb-4" data-id="element-216">
            ⭐ CO MÓWIĄ TRENERZY
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-text-main tracking-tight mb-4" data-id="element-217">
            Ponad 800 trenerów skorzystało już z tych materiałów.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6" data-id="element-218">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-2xl p-6 sm:p-7 flex flex-col gap-4 hover:border-primary/40 transition-colors" data-id="element-219">
              <div className="flex items-center gap-1 text-secondary text-lg" aria-label="5 stelle su 5" data-id="element-220">
                ⭐⭐⭐⭐⭐
              </div>
              <p className="text-text-main text-[15px] sm:text-base leading-relaxed font-medium flex-1" data-id="element-221">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-222">
                <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${t.color} border-2 border-primary/30 flex items-center justify-center flex-shrink-0`} aria-hidden="true" data-id="element-223">
                  <span className="text-text-main font-black text-sm tracking-wide" data-id="element-224">
                    {t.initials}
                  </span>
                </div>
                <div data-id="element-225">
                  <p className="text-text-main font-bold text-sm" data-id="element-226">{t.name}</p>
                  <p className="text-text-sec text-xs font-medium" data-id="element-227">{t.role}</p>
                </div>
                <span className="ml-auto text-check-green text-xs font-bold flex items-center gap-1" title="Zweryfikowana opinia" data-id="element-228">
                  ✓ Zweryfikowana opinia
                </span>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}